import styles from "../assets/styles/pages/home.module.css";
import HomeSection from "../componenets/HomeSection";
import Teachers from "../componenets/Teachers";
import AboutUs from "../componenets/AboutUs";
import NavBar from "../componenets/NavBar";
import Footer from "../componenets/Footer";
import Lessons from "../componenets/Lessons";
import { useTeacherContext } from "../context/teacherCVContext";
import TeacherCv from "../componenets/TeacherCv";

export default function Home() {
    const { selectedTeacher } = useTeacherContext();

    return (
        <div className={styles.main}>
            <NavBar />
            <HomeSection />
            <Lessons />
            <Teachers />
            <AboutUs />
            <Footer />
            {selectedTeacher && <TeacherCv />}
        </div>
    );
}
